<template>
  <div class="demo-chat-area" ref="cont">
    <div class="message-list" ref="list">

        <TransitionGroup name="list" tag="div">
        <div
          class="message-row"
          v-for="message in messages"
          :key="message.lastMessageId"
          ref="message"
        >

          <div 
            :class="[
              'message-item',
              {
                'message-sent': message.isMe,
                'message-received': !message.isMe,
                'message-recevied-sticker': !message.isMe && !message.answer,
                'message-cover-sticker': message.stickerCat === 'bird'
              }
            ]"
          >
            <template v-if="message.isMe">
              <img :src="$getImgUrl(`assets/stickers/${message.stickerCat}/${message.stickerIndex}.webp`)" />
            </template>
            <template v-else>
              <div class="profile">
                <svgProfile />
              </div>
              <div class="bubble" v-if="message.answer">
                {{message.answer}}
              </div>
              <div 
                v-else
                :class="[
                  'answer-sticker'
                ]"
              >
                <img :src="$getImgUrl(`assets/stickers/${message.stickerCat}/${message.stickerIndex}.webp`)" alt="">
              </div>
            </template>
          </div>

        </div>
        </TransitionGroup>
    </div>
  </div>
</template>

<script>
import svgProfile from "@/svg/svgProfile"
export default {
  props: {
    messages: Array
  },
  watch: {
    messageLen(n, o) {
      console.log(n, o)
      this.scrollToNewest()
    },
  },
  computed: {
    messageLen() {
      return this.messages.length
    }
  },
  methods: {
    scrollToNewest() {
      // console.log({
      //   scrollTop: this.$refs.cont.scrollTop,
        
      // })
      if (!this.$refs.cont) return
      this.$nextTick(()=> {
        console.log(this.$refs.message, this.messageLen)
        // this.$refs.message[this.messageLen - 1]?.scrollIntoView()
        this.$refs.cont.scrollTop = this.$refs.cont.scrollHeight - this.$refs.cont.clientHeight
      })
      // this.$refs.cont.children.lastChild.scrollIntoView()
    }
  },
  components: {
    svgProfile
  }
}
</script>


<style lang="scss" scoped>
.demo-chat-area {
  padding: 25px 0;
  overflow: auto;
  height: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
}

.message-list {

}

.message-row {
  position: relative;
  display: flex;
  padding: 0 40px;
  @media screen and (max-width: 768px) {
    padding: 0 25px;
  }
  @media screen and (max-width: 480px) {
    padding: 0 11px;
  }
  @media screen and (max-width: 480px) {
    padding: 4px 10px;
  }
}

.message-sent {
  margin-left: auto;
  width: 120px;
  height: 120px;
  // background-color: white;
  border-radius: 13px;
  display: flex;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: auto;
    margin: auto;
  }
}

.message-received {
  display: flex;
}

.message-recevied-sticker {
  margin-top: -48px;
}

.profile {
  width: 45px;
  height: 45px;
  display: flex;
  svg {
    display: block;
    width: 100%;
    margin: auto;
    height: auto;
  }
}

.bubble {
  padding: 12px;
  background-color: white;
  color: #171717;
  font-size: 14px;
  font-weight: 500;
  border-radius: 10px;
  margin-left: 15px;
  flex: none;
  display: flex;
  min-height: 37px;
  align-items: center;
}

.answer-sticker {
  width: 120px;
  height: 120px;
  overflow: hidden;
  // background-color: white;
  border-radius: 13px;
  display: flex;
  margin-left: 15px;
  img {
    display: block;
    width: 100%;
    height: auto;
    margin: auto;
  }
}

.message-cover-sticker img,
.message-cover-sticker .answer-sticker img {
  object-fit: cover;
  height: 100%;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translate3d(0, 50%, 0);
}
</style>